module.exports = __webpack_public_path__ + "48bc17020f2267ca5e8e3ef9c2413211.svg";